export class Option<T> {
  value: T;
  text: string;
  exclusive?: boolean;
  disabled?: boolean;
}
